// hooks/travelPlan/validateTravelPlan.js

export const TRAVEL_PLAN_TYPES = {
    CONFERENCE: 'Conference',
    TRAINING: 'Training',
    WORKSHOP: 'Workshop'
};

export const validateTravelPlan = (plan) => {
    const errors = {};
    const requiredFields = {
        destination: 'Destination',
        type: 'Type',
        start_date: 'Start date',
        return_date: 'Return date',
        departure_time: 'Departure time',
        return_time: 'Return time',
        province: 'Province',
        district: 'District',
        location: 'Location'
    };

    Object.entries(requiredFields).forEach(([field, label]) => {
        if (!plan[field]) {
            errors[field] = `${label} is required`;
        }
    });

    if (plan.start_date && plan.return_date && new Date(plan.start_date) > new Date(plan.return_date)) {
        errors.return_date = 'Return date must be after start date';
    }

    if (plan.type && !Object.values(TRAVEL_PLAN_TYPES).includes(plan.type)) {
        errors.type = 'Invalid travel plan type';
    }

    return { isValid: Object.keys(errors).length === 0, errors };
};
